// extracted by mini-css-extract-plugin
export default {"root":"KVI08qgL","brandingLink":"MTwslNLO","logo":"_3T0XC1rE","description":"_20xn6rvA"};